/* One mutation path for cart page and drawer; Shopify owns all pricing. */
(() => {
  if (window.RedLineCart) return;
  const fr = document.documentElement.lang.startsWith('fr');
  const copy = {
    pending: fr ? 'Mise à jour du panier…' : 'Updating your cart…',
    retrying: fr ? 'Actualisation du panier…' : 'Refreshing your cart…',
    refreshed: fr ? 'Panier actualisé. Vous pouvez continuer.' : 'Cart refreshed. You can continue.',
    error: fr ? 'Impossible de confirmer la mise à jour. Réessayez ou actualisez la page avant de payer.' : 'We could not confirm the update. Try again or refresh before checkout.',
    updated: fr ? 'Panier mis à jour.' : 'Cart updated.',
    limited: fr ? 'La quantité a été ajustée à la disponibilité actuelle.' : 'Quantity was adjusted to current availability.',
    status: fr ? 'État du panier' : 'Cart status',
    update: fr ? 'Mise à jour' : 'Cart update',
    recoveredTitle: fr ? 'Panier vérifié et rétabli.' : 'Cart checked and restored.',
    recoveryTitle: fr ? 'Votre panier doit être actualisé.' : 'Your cart needs a quick refresh.',
    refresh: fr ? 'Actualiser le panier' : 'Refresh cart',
    preserved: fr ? 'Vos articles resteront dans le panier.' : 'Your items will stay in your cart.'
  };
  const api = window.RedLineCart = {
    pending: false, failed: false, checkout: null,
    sections() {
      const list = [{id:'Cart-Drawer', section:'cart-drawer', selector:'.side-panel-content'}, {id:'cart-drawer-toggle', section:'cart-bubble', selector:'.float_count'}];
      const cart = document.getElementById('Cart');
      if (cart) list.unshift({id:'Cart', section:cart.dataset.id, selector:'.thb-cart-form-container'});
      return list.filter(s => document.getElementById(s.id));
    },
    message(text, state = 'status') {
      for (const root of document.querySelectorAll('#Cart, #Cart-Drawer .side-panel-content')) {
        let el = root.querySelector('.rl-cart-message');
        if (!el) {
          el = document.createElement('div');
          el.className = 'rl-cart-message';
          el.setAttribute('aria-live','polite');
          el.setAttribute('aria-atomic','true');
          root.prepend(el);
        }
        const mode = state === true ? 'error' : state;
        el.className = `rl-cart-message rl-cart-message--${mode}`;
        el.setAttribute('role',mode === 'error' ? 'alert' : 'status');
        el.replaceChildren();

        const heading = document.createElement('div');
        heading.className = 'rl-cart-message__heading';
        const label = document.createElement('span');
        label.className = 'rl-cart-message__label';
        label.textContent = mode === 'pending' ? copy.update : copy.status;
        heading.append(label);

        if (mode === 'error' || mode === 'recovered') {
          const title = document.createElement('strong');
          title.className = 'rl-cart-message__title';
          title.textContent = mode === 'error' ? copy.recoveryTitle : copy.recoveredTitle;
          heading.append(title);
        }

        const body = document.createElement('p');
        body.className = 'rl-cart-message__body';
        body.textContent = text;
        el.append(heading,body);

        if (mode === 'error') {
          const actions = document.createElement('div');
          actions.className = 'rl-cart-message__actions';
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'rl-cart-message__action';
          button.dataset.rlCartRefresh = '';
          button.textContent = copy.refresh;
          const note = document.createElement('small');
          note.className = 'rl-cart-message__note';
          note.textContent = copy.preserved;
          actions.append(button,note);
          el.append(actions);
        }
      }
    },
    busy(value) {
      this.pending = value;
      document.body.classList.toggle('rl-cart-pending',value);
      for (const root of document.querySelectorAll('#Cart, #Cart-Drawer')) {
        root.setAttribute('aria-busy',String(value));
        root.querySelectorAll('.qty,.plus,.minus,.remove,[name="checkout"],.shipping-estimator--submit').forEach(el => {
          if ('disabled' in el) el.disabled = value || (this.failed && el.name === 'checkout');
          el.setAttribute('aria-disabled',String(value));
        });
        root.querySelectorAll('.additional-checkout-buttons').forEach(el => el.inert = value || this.failed);
      }
    },
    async refresh() {
      const url = new URL(location.href); url.searchParams.set('sections',this.sections().map(s=>s.section).join(','));
      const response = await fetch(url,{cache:'no-store',signal:AbortSignal.timeout(15000)});
      if (!response.ok) throw new Error(copy.error);
      this.render(await response.json());
    },
    async recover() {
      if (this.pending) return;
      this.busy(true);
      this.message(copy.retrying,'pending');
      try {
        await this.refresh();
        this.failed=false;
        this.message(copy.refreshed,'status');
      } catch (_) {
        this.failed=true;
        this.message(copy.error,'error');
      } finally {
        this.busy(false);
      }
    },
    render(sections) {
      const active = document.activeElement;
      const activeKey = this.focusContext?.key || active?.dataset.key || active?.closest('quantity-selector')?.querySelector('.qty')?.dataset.key;
      const activeRoot = this.focusContext?.root || active?.closest('#Cart, #Cart-Drawer')?.id;
      const activeClass = this.focusContext?.control || (active?.classList.contains('plus') ? '.plus' : active?.classList.contains('minus') ? '.minus' : '.qty');
      const retained = [...document.querySelectorAll('#CartSpecialInstructions,#mini-cart__notes,#CartTerms,#CartDrawerTerms')].map(el=>({id:el.id,value:el.value,checked:el.checked}));
      const estimator = document.querySelector('shipping-estimator');
      const destination = estimator ? ['country','province','zip'].map(x=>estimator.querySelector('.shipping-estimator-'+x)?.value) : null;
      for (const section of this.sections()) {
        if (!sections[section.section]) throw new Error(copy.error);
        const next = new DOMParser().parseFromString(sections[section.section],'text/html').querySelector(section.selector);
        const root = document.getElementById(section.id);
        const target = root.querySelector(section.selector) || root;
        if (!next) throw new Error(copy.error);
        target.innerHTML = next.innerHTML;
      }
      for(const saved of retained){const el=document.getElementById(saved.id);if(el){el.value=saved.value;if(el.type==='checkbox')el.checked=saved.checked;}}
      const nextEstimator = document.querySelector('shipping-estimator');
      if (nextEstimator && destination) {
        ['country','province','zip'].forEach((name,i)=>{
          const input=nextEstimator.querySelector('.shipping-estimator-'+name);
          if (input && destination[i] != null) { input.value=destination[i]; if(name==='country') input.dispatchEvent(new Event('change')); }
        });
      }
      document.querySelector('#Cart-Drawer')?.cartDrawerInstance?.notesToggle();
      const toggle=document.getElementById('cart-drawer-toggle');
      if(toggle)toggle.setAttribute('aria-label',`${fr?'Panier':'Cart'} (${toggle.querySelector('.float_count')?.textContent.trim() || '0'})`);
      if (activeKey) {
        const root=document.getElementById(activeRoot);
        const input=[...(root?.querySelectorAll('.qty') || [])].find(x=>x.dataset.key===activeKey && x.getClientRects().length);
        (input?.closest('quantity-selector')?.querySelector(activeClass) || input)?.focus({preventScroll:true});
      }
    },
    async change(key, quantity) {
      if (this.pending) return;
      if (!key || !Number.isInteger(quantity) || quantity < 0) { document.querySelectorAll('.qty[data-key]').forEach(el=>{if(el.dataset.key===key)el.value=el.dataset.confirmed;});this.message(copy.error,'recovered'); return; }
      const active=document.activeElement;
      this.focusContext={key,root:active?.closest('#Cart,#Cart-Drawer')?.id,control:active?.classList.contains('plus')?'.plus':active?.classList.contains('minus')?'.minus':'.qty'};
      this.failed=false; this.busy(true); this.message(copy.pending,'pending');
      document.querySelectorAll('shipping-estimator').forEach(el=>el.invalidate?.());
      try {
        const response=await fetch(theme.routes.cart_change_url,{signal:AbortSignal.timeout(15000),method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity,sections:this.sections().map(s=>s.section),sections_url:location.pathname})});
        const state=await response.json();
        if (!response.ok || state.errors || state.status) { const error=new Error(copy.error);error.publicMessage=typeof state.description==='string'?state.description:typeof state.errors==='string'?state.errors:copy.error;throw error; }
        this.render(state.sections);
        const accepted=state.items.find(item=>item.key===key)?.quantity || 0;
        this.message(accepted===quantity?copy.updated:copy.limited);
        document.dispatchEvent(new CustomEvent('line-item:change:end',{detail:{quantity:accepted,cart:state}}));
      } catch (error) {
        this.checkout=null;
        let recovered=true;
        try { await this.refresh(); } catch (_) { recovered=false; this.failed=true; }
        this.message(error.publicMessage || copy.error,recovered?'recovered':'error');
      } finally {
        this.busy(false); this.focusContext=null;
        const checkout=this.checkout; this.checkout=null;
        if(checkout && !this.failed) this.submit(checkout);
      }
    },
    submit(rootId) {
      const root=document.getElementById(rootId);
      const button=root?.querySelector('[name="checkout"]');
      const terms=root?.querySelector('#CartTerms,#CartDrawerTerms');
      if(terms && !terms.checked) { terms.reportValidity(); terms.focus(); return; }
      if(button?.form) button.form.requestSubmit(button);
    }
  };
  document.addEventListener('change',event=>{
    const input=event.target;
    if(!input.matches('#Cart .qty,#Cart-Drawer .qty')) return;
    event.stopImmediatePropagation();
    api.change(input.dataset.key,Number(input.value));
  },true);
  document.addEventListener('click',event=>{
    const root=event.target.closest('#Cart,#Cart-Drawer'); if(!root)return;
    if(event.target.closest('[data-rl-cart-refresh]')){event.preventDefault();event.stopImmediatePropagation();api.recover();return;}
    const remove=event.target.closest('.remove');
    if(remove){event.preventDefault();event.stopImmediatePropagation();api.change(remove.dataset.key,0);return;}
    if(api.pending && event.target.closest('quantity-selector,.additional-checkout-buttons')) {event.preventDefault();event.stopImmediatePropagation();return;}
    if(event.target.closest('[name="checkout"]') && (api.pending||api.failed)) {
      event.preventDefault();event.stopImmediatePropagation();if(api.pending)api.checkout=root.id;else api.message(copy.error,'error');
    }
  },true);
  document.addEventListener('submit',event=>{
    const root=event.target.closest('#Cart,#Cart-Drawer'); if(!root)return;
    if(api.pending||api.failed) {event.preventDefault();event.stopImmediatePropagation();if(api.pending)api.checkout=root.id;else api.message(copy.error,'error');return;}
    const terms=root.querySelector('#CartTerms,#CartDrawerTerms');
    if(terms&&!terms.checked){event.preventDefault();terms.reportValidity();terms.focus();}
  },true);
  document.addEventListener('cart:refresh',()=>{if(!api.pending)api.refresh().catch(()=>{api.failed=true;api.message(copy.error,'error');});});
})();
